<!-- `con-franja-once`: la franja del 11.11 está a la vista y el contenido arranca debajo de
     ella (app.component.scss). Va en el HTML del servidor, así que no hay salto al arrancar. -->
<ion-app [class.con-franja-once]="franja.visible()">

  <app-toolbar
    [categories]="categories"
    [bigCategories]="bigCategories"
    [stores]="stores"
    [url]="url()"
  >
    <!-- Franja «Especial 11.11» con cuenta atrás hacia /11-11/ (02/11/2026); se quita sola al terminar.
         Va DENTRO de la cabecera (proyectada): suelta en ion-app, Ionic la empujaba al fondo con
         `justify-content: space-between` al arrancar y quedaba detrás de ion-router-outlet
         («y te habia pedido una banda del 11 del 11 ahi», 02/11/2026). -->
    <app-franja-once #franja [url]="url()"></app-franja-once>
  </app-toolbar>

  <!-- Sin animación de página (31/10/2026): el fundido de Ionic dejaba la home y la ficha
       superpuestas a medias unos 100 ms en cada ida y vuelta, y eso era el parpadeo. -->
  <ion-router-outlet id="main" [animated]="false"></ion-router-outlet>

  <app-barra-inferior [url]="url()"></app-barra-inferior>

  <!-- Aviso propio para activar las notificaciones del navegador (02/11/2026); solo con sesión y permiso sin decidir. -->
  <app-aviso-notificaciones></app-aviso-notificaciones>

  <!-- Asistente de voz oculto: solo se monta con el código secreto (odd/tasks/asistente-voz.md). -->
  <ng-container #anclaAsistente></ng-container>

  @if (showCookies()) {
    <app-cookies-bar (consent)="onConsent($event)"></app-cookies-bar>
  }
</ion-app>